import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="grid min-h-screen place-items-center p-8">
      <div className="text-center">
        <p className="text-sm font-medium text-muted-foreground">404</p>
        <h1 className="mt-2 text-3xl font-semibold">Page not found</h1>
        <Link to="/" className="mt-4 inline-block text-primary hover:underline">
          Back to Command Center
        </Link>
      </div>
    </div>
  );
}
